export const REDIRECT_CATEGORY_ID = 'redirectCategoryId';
